import { render, staticRenderFns } from "./PurchasingGroup.vue?vue&type=template&id=40bf4d11"
import script from "./PurchasingGroup.vue?vue&type=script&lang=js"
export * from "./PurchasingGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports